import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useGetList, useRecordContext } from 'react-admin';
import { useFormContext } from 'react-hook-form';
import {
  FilterEnumMultiselectChip,
  FilterMultiselectChip,
  FilterTextChip,
} from 'shared/mui/Filter/FilterChipsToolbar/FilterChips';
import { AutocompleteMultiselectInput, TextInput } from 'shared/react-admin/Inputs';
import { ReferenceArrayInput } from 'shared/react-admin/ReferenceInputs';
import { Currency } from 'types/embedded/currency';
import { Merchant } from 'types/embedded/merchant';

export const MerchantShowCommissionsListFilterChips: React.FC = () => {
  const translate = useTypedTranslate();
  const { data: commissionStatuses } = useGetList('commission_statuses');
  const { getValues } = useFormContext();
  const record = useRecordContext<Merchant>();

  return (
    <>
      <FilterTextChip label={translate('app.filter.name')} name="name">
        <TextInput
          fullWidth={true}
          helperText={false}
          key="name"
          label={translate('app.filter.name')}
          resettable
          source="name"
          variant="outlined"
        />
      </FilterTextChip>
      <FilterEnumMultiselectChip
        label={translate('app.filter.statuses')}
        limitTags={1}
        name="status"
        resource="commission_statuses"
      >
        <AutocompleteMultiselectInput
          defaultValue={getValues('status')}
          helperText={false}
          label={translate('app.filter.statuses')}
          name="status"
          optionText="description"
          optionValue="value"
          options={commissionStatuses || []}
        />
      </FilterEnumMultiselectChip>
      <FilterMultiselectChip
        label={translate('app.filter.providers')}
        limitTags={1}
        name="provider"
        resource="providers"
      >
        <ReferenceArrayInput
          filter={{ 'commissions.merchant': record?.id }}
          perPage={100}
          reference="providers"
          sort={{ field: 'name', order: 'ASC' }}
          source="provider"
        >
          <AutocompleteMultiselectInput
            clearOnBlur={false}
            filterToQuery={(searchText: string) => ({ name: searchText })}
            helperText={false}
            label={translate('app.filter.providers')}
            name="provider"
            optionText="name"
          />
        </ReferenceArrayInput>
      </FilterMultiselectChip>
      <FilterMultiselectChip
        label={translate('app.filter.currencies')}
        limitTags={1}
        name="currency.id"
        resource="currencies"
      >
        <ReferenceArrayInput
          filter={{ active: true }}
          perPage={50}
          reference="currencies"
          source="currency.id"
        >
          <AutocompleteMultiselectInput
            filterToQuery={(searchText: string) => ({ currency: searchText })}
            getOptionLabel={(record: Currency) => `${record?.alphaCode}, ${record?.name}`}
            helperText={false}
            label={translate('app.filter.currencies')}
            name="currency.id"
          />
        </ReferenceArrayInput>
      </FilterMultiselectChip>
      <FilterMultiselectChip
        label={translate('app.commissions.transactionTypes')}
        limitTags={1}
        name="transactionTypes"
        resource="transaction_types"
      >
        <ReferenceArrayInput perPage={100} reference="transaction_types" source="transactionTypes">
          <AutocompleteMultiselectInput
            helperText={false}
            label={translate('app.commissions.transactionTypes')}
            name="transactionTypes"
            optionText="name"
          />
        </ReferenceArrayInput>
      </FilterMultiselectChip>
      <FilterTextChip label={translate('app.merchantCommissions.feeId')} name="id">
        <TextInput
          fullWidth={true}
          helperText={false}
          label={translate('app.merchantCommissions.feeId')}
          resettable
          source="id"
          variant="outlined"
        />
      </FilterTextChip>
      <FilterTextChip label={translate('app.merchantCommissions.parentFeeId')} name="parent.id">
        <TextInput
          fullWidth={true}
          helperText={false}
          label={translate('app.merchantCommissions.parentFeeId')}
          resettable
          source="parent.id"
          variant="outlined"
        />
      </FilterTextChip>
    </>
  );
};
